/* eslint-disable */
import styled from 'styled-components';
import { flexbox, alignItems, justifyContent } from '../../styles/helpers/flexbox';

const ActionRendererWrapper = styled.div`
    ${flexbox()}
    ${alignItems('center')}
    ${justifyContent('center')}
`;
const ReacTableStyles = styled.div`
display: inherit;
`;

export { ReacTableStyles, ActionRendererWrapper };



// WEBPACK FOOTER //
// ./app/components/data-table/styled.js